import React from 'react';
import { Content, Header, Page } from '@backstage/core-components';
import { WikiSectionsCard } from './WikiSectionsCard';

export const WikiPage = () => (
  <Page themeId="documentation">
    <Header title="Legacy Wiki" />
    <Content>
      <WikiSectionsCard />
    </Content>
  </Page>
);
